<template>
  <div class="recruitment-dashboard" :class="showAdd ? 'page-hide' : ''">
    <!-- 頂部標題欄 -->
    <div class="page-title u-flex">
      <div>
        <div class="page-title-main">學生管理</div>
        <div class="page-title-sub">大學問總管理中心</div>
      </div>
    </div>

    <div class="era-content-grid">
      <!-- 左侧排行榜 -->
      <section class="era-ranking-section">
        <div class="era-section-header">
          <div class="era-section-title u-flex page-filter-top align-start">
            <div
              class="u-flex"
              style="flex-grow: 1; padding-right: 5%; align-items: flex-start"
            >
              <div
                class="u-flex page-filter flex-wrap gap-10"
                style="flex-grow: 1"
              >
                <el-input
                  clearable
                  @blur="initData"
                  @keyup.enter.native="initData"
                  class="input-date input-date1"
                  v-model="search.studentId"
                  type="text"
                  placeholder="搜尋學生ID"
                >
                </el-input>
                <el-input
                  clearable
                  @blur="initData"
                  @keyup.enter.native="initData"
                  class="input-date input-date1"
                  v-model="search.keyword"
                  type="text"
                  placeholder="搜尋學生姓名/昵称"
                >
                </el-input>
                <el-input
                  clearable
                  @blur="initData"
                  @keyup.enter.native="initData"
                  class="input-date input-date1"
                  v-model="search.phone"
                  type="text"
                  placeholder="搜尋學生手機"
                >
                </el-input>
                <el-input
                  clearable
                  @blur="initData"
                  @keyup.enter.native="initData"
                  class="input-date input-date1"
                  v-model="search.email"
                  type="text"
                  placeholder="搜尋學生邮箱"
                >
                </el-input>
                <template v-if="showMoreInput">
                  <el-select
                    @change="initData"
                    filterable
                    clearable
                    placeholder="用戶類型"
                    class="input-date"
                    v-model="search.userType"
                  >
                    <el-option label="學生" value="student"></el-option>
                    <el-option label="家長" value="parent"></el-option>
                  </el-select>
                  <el-select
                    @change="initData"
                    clearable
                    placeholder="狀態"
                    class="input-date"
                    v-model="search.status"
                  >
                    <el-option label="正常" value="0"> </el-option>
                    <el-option label="停用" value="1"> </el-option>
                  </el-select>
                  <el-select
                    @change="initData"
                    clearable
                    placeholder="學制"
                    class="input-date"
                    v-model="search.studentStage"
                  >
                    <el-option label="初中" value="JUNIOR_HIGH"> </el-option>
                    <el-option label="高中" value="SENIOR_VOCATIONAL">
                    </el-option>
                  </el-select>
                  <el-select
                    @change="initData"
                    filterable
                    clearable
                    placeholder="就讀縣市"
                    class="input-date"
                    v-model="search.city"
                  >
                    <el-option
                      v-for="item in sys_area"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    @change="initData"
                    filterable
                    clearable
                    placeholder="是否已支付"
                    class="input-date"
                    v-model="search.hasPaidSubscription"
                  >
                    <el-option label="是" value="true"> </el-option>
                    <el-option label="否" value="false"> </el-option>
                  </el-select>
                  <el-select
                    @change="initData"
                    filterable
                    clearable
                    placeholder="訂閲狀態"
                    class="input-date"
                    v-model="search.subscriptionStatus"
                  >
                    <el-option label="激活" value="ACTIVE"> </el-option>
                    <el-option label="已過期" value="EXPIRED"> </el-option>
                    <el-option label="無訂閲" value="NONE"> </el-option>
                  </el-select>
                  <el-date-picker
                    v-model="search.beginCreateTime"
                    type="date"
                    placeholder="选择创建时间"
                    class="input-date"
                    @change="initData"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                  <el-date-picker
                    v-model="search.beginLoginDate"
                    type="date"
                    placeholder="选择登录时间"
                    class="input-date"
                    @change="initData"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                  <el-date-picker
                    v-model="search.beginSubscriptionExpireTime"
                    type="date"
                    placeholder="选择訂閲时间"
                    class="input-date"
                    @change="initData"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                  <el-date-picker
                    v-model="search.endSubscriptionExpireTime"
                    type="date"
                    placeholder="选择訂閲到期时间"
                    class="input-date"
                    @change="initData"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </template>
              </div>
              <div
                class="title-btn"
                style="margin-left: 10px; flex-shrink: 0"
                @click="showMoreInput = !showMoreInput"
              >
                {{ showMoreInput ? "收起" : "更多" }}
              </div>
            </div>

            <div class="title-btn shrink" @click="toAdd()">
              <i class="el-icon-plus" style="margin-right: 0.02rem"></i>
              新增學生
            </div>
          </div>
        </div>

        <div class="era-table-container">
          <div class="ranking-table" style="margin-top: 0; min-width: 1000px">
            <div class="table-header">
              <span class="w3">Email</span>
              <span class="w2">手機號碼</span>
              <span class="w2">姓名</span>
              <span class="w1">AI免費次數</span>
              <span class="w1">AI訂閲數/天</span>
              <span class="w2">訂閲到期日期</span>
              <span class="wp5">狀態</span>
              <span class="fixed-col w2">操作</span>
            </div>
            <div
              class="table-row"
              v-for="(item, index) in dataList"
              :key="item.id"
            >
              <span class="w3">{{ item.email }}</span>
              <span class="w2">{{ item.phone || "--" }}</span>
              <span class="w2">{{ item.name || item.nickName || "--" }}</span>
              <span class="w1">{{ item.aiRemainCount || 0 }}</span>
              <span class="w1"
                >{{ item.aiSubscriptionRemainCount || 0 }}/天</span
              >
              <span class="w2">{{ item.subscriptionExpireTime || "--" }}</span>
              <span class="wp5">
                {{ item.status == 0 ? "正常" : "停用" }}
              </span>
              <span class="item-btn fixed-col w2">
                <div class="btn btn-edit" @click="toSee(item, true)">編輯</div>
                <div class="btn btn-edit" @click="deleteStudent(item)">
                  刪除
                </div>
              </span>
            </div>
          </div>
        </div>
        <div
          class="era-search u-flex"
          style="justify-content: center; margin-top: 0.2rem"
        >
          <el-pagination
            @current-change="currentChange"
            background
            layout="prev, pager, next"
            :total="dataTotal"
          >
          </el-pagination>
        </div>
      </section>

      <!-- 新增/编辑學生信息 -->
      <div class="dialog-fixed-right" :class="showAdd ? 'show' : ''">
        <div class="dialog-fixed-modal" v-if="showAdd"></div>
        <div class="dialog-fixed-content">
          <div class="title" style="margin-top: 0.1rem">
            {{ post.id ? "編輯" : "新增" }}學生資料
            <span @click="showAdd = false">
              <i class="el-icon-close" style="font-size: 0.3rem"></i>
            </span>
          </div>
          <div>
            <div class="title">基本資料</div>
            <div class="date-container">
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">Email</label>
                <el-input
                  class="input-date"
                  v-model="post.email"
                  type="text"
                  placeholder="請輸入Email"
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">密碼</label>
                <el-input
                  class="input-date"
                  v-model="post.password"
                  type="password"
                  placeholder="請輸入密碼"
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">手機號碼</label>
                <el-input
                  class="input-date"
                  v-model="post.phone"
                  type="text"
                  placeholder="請輸入手機號碼"
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">姓名</label>
                <el-input
                  class="input-date"
                  v-model="post.name"
                  type="text"
                  placeholder="請輸入姓名"
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">用戶類型</label>
                <el-select
                  placeholder="請選擇用戶類型"
                  class="input-date"
                  v-model="post.userType"
                >
                  <el-option label="學生" value="student"> </el-option>
                  <el-option label="家長" value="parent"> </el-option>
                </el-select>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">學制</label>
                <el-select
                  placeholder="請輸入學制"
                  class="input-date"
                  v-model="post.studentStage"
                >
                  <el-option
                    v-for="item in studentStageList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">就讀縣市</label>
                <el-select
                  filterable
                  clearable
                  placeholder="就讀縣市"
                  class="input-date"
                  v-model="post.city"
                >
                  <el-option
                    v-for="item in sys_area"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </div>
              <template v-if="post.studentStage === 'JUNIOR_HIGH'">
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">目标学校类型</label>
                  <el-input
                    class="input-date"
                    v-model="post.targetSchoolType"
                    type="text"
                    placeholder="請輸入目标学校类型"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">通勤距离偏好</label>
                  <el-input
                    class="input-date"
                    v-model="post.commuteDistancePreference"
                    type="text"
                    placeholder="請輸入通勤距离偏好"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">会考成绩</label>
                  <el-input
                    class="input-date"
                    v-model="post.examScores"
                    type="text"
                    placeholder="請輸入会考成绩"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">可用次数</label>
                  <el-input
                    class="input-date"
                    v-model="post.availableCount"
                    type="text"
                    placeholder="請輸入可用次数"
                  >
                  </el-input>
                </div>
              </template>
              <template v-if="post.studentStage === 'SENIOR_VOCATIONAL'">
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">就读学校</label>
                  <el-input
                    class="input-date"
                    v-model="post.schoolName"
                    type="text"
                    placeholder="請輸入就读学校"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">会考总分</label>
                  <el-input
                    class="input-date"
                    v-model="post.totalScore"
                    type="text"
                    placeholder="請輸入会考总分"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                  v-if="post.currentChatQuotaType === 'FREE'"
                >
                  <label class="date-label">AI 免费剩余次数</label>
                  <el-input
                    class="input-date"
                    v-model="post.aiRemainCount"
                    type="text"
                    placeholder="請輸入免费剩余次数"
                  >
                  </el-input>
                </div>
                <template v-if="post.currentChatQuotaType === 'SUBSCRIPTION'">
                  <div
                    class="date-input-group"
                    style="width: 24%; min-width: 24%"
                  >
                    <label class="date-label">AI 订阅每日剩余次数</label>
                    <el-input
                      class="input-date"
                      v-model="post.aiSubscriptionRemainCount"
                      type="text"
                      placeholder="請輸入订阅每日剩余次数"
                    >
                    </el-input>
                  </div>
                  <div
                    class="date-input-group"
                    style="width: 24%; min-width: 24%"
                  >
                    <label class="date-label">订阅到期日</label>
                    <el-date-picker
                      class="input-date"
                      v-model="post.subscriptionExpireTime"
                      type="date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="請輸入订阅到期日"
                    >
                    </el-date-picker>
                  </div>
                </template>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                  v-if="isEdit"
                >
                  <label class="date-label">当前实际使用的聊天额度类型</label>
                  <el-select
                    v-model="post.currentChatQuotaType"
                    placeholder="請選擇"
                  >
                    <el-option
                      v-for="item in chatQuotaTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                  v-if="isEdit"
                >
                  <label class="date-label">当前聊天额度剩余次数</label>
                  <el-input
                    class="input-date"
                    v-model="post.currentChatQuotaRemaining"
                    type="text"
                    placeholder="請輸入当前聊天额度剩余次数"
                    disabled
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                  v-if="post.currentChatQuotaLimit"
                >
                  <label class="date-label">
                    当前每日聊天额度(已使用/上限)
                  </label>
                  <el-input
                    class="input-date"
                    :value="`${post.currentChatQuotaUsed || 0}/${
                      post.currentChatQuotaLimit
                    }`"
                    type="text"
                    placeholder="請輸入当前每日聊天额度上限"
                    disabled
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                  v-if="post.currentChatQuotaType === 'WELCOME_BENEFIT'"
                >
                  <label class="date-label">当前欢迎语权益到期时间</label>
                  <el-input
                    class="input-date"
                    v-model="post.welcomeBenefitExpireTime"
                    type="text"
                    placeholder="請輸入当前欢迎语权益到期时间"
                  >
                  </el-input>
                </div>
              </template>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">备注</label>
                <el-input
                  class="input-date"
                  v-model="post.remark"
                  type="text"
                  placeholder="請輸入备注"
                >
                </el-input>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label"> 重要通知开关</label>
                <el-switch
                  v-model="post.importantNoticeEnabled"
                  active-color="#0BA29B"
                  inactive-color="#DCDFE6"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="通知"
                >
                </el-switch>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label"> 服务更新开关</label>
                <el-switch
                  v-model="post.serviceUpdateEnabled"
                  active-color="#0BA29B"
                  inactive-color="#DCDFE6"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="更新"
                >
                </el-switch>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label"> 到期提醒开关</label>
                <el-switch
                  v-model="post.serviceExpiryEnabled"
                  active-color="#0BA29B"
                  inactive-color="#DCDFE6"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="提醒"
                >
                </el-switch>
              </div>
              <div class="date-input-group" style="width: 24%; min-width: 24%">
                <label class="date-label">账号状态</label>
                <el-switch
                  v-model="post.status"
                  active-color="#0BA29B"
                  inactive-color="#DCDFE6"
                  :active-value="0"
                  :inactive-value="1"
                  active-text="停用"
                >
                </el-switch>
              </div>
            </div>
            <template v-if="!isEdit">
              <div class="title">綫下訂閲信息</div>
              <div class="date-container">
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">業務訂單號</label>
                  <el-input
                    class="input-date"
                    v-model="offlineSubscription.merchantTradeNo"
                    type="text"
                    placeholder="請輸入業務訂單號，最长 32 位"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">套餐</label>
                  <el-select
                    filterable
                    clearable
                    placeholder="請選擇啟用套餐"
                    class="input-date"
                    v-model="offlineSubscription.planId"
                  >
                    <el-option
                      v-for="item in plans"
                      :key="item.id"
                      :label="item.planName"
                      :value="item.id"
                    />
                  </el-select>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">實收金額</label>
                  <el-input
                    class="input-date"
                    v-model="offlineSubscription.paidAmount"
                    type="text"
                    placeholder="請輸入實收金額"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">折扣原因</label>
                  <el-input
                    class="input-date"
                    v-model="offlineSubscription.discountReason"
                    type="text"
                    placeholder="請輸入實付和套餐金額不一樣原因"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">支付時間</label>
                  <el-date-picker
                    v-model="offlineSubscription.paidTime"
                    type="datetime"
                    placeholder="选择支付時間"
                    class="input-date"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">支付方式</label>
                  <el-select
                    v-model="offlineSubscription.paymentMethod"
                    placeholder="請選擇支付方式"
                  >
                    <el-option label="綫下轉賬" value="OFFLINE_TRANSFER" />
                    <el-option label="現金" value="OFFLINE_CASH" />
                    <el-option label="銀行轉帳" value="OFFLINE_BANK" />
                  </el-select>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">是否開票</label>
                  <el-switch
                    v-model="offlineSubscription.invoiceRequired"
                    active-color="#0BA29B"
                    inactive-color="#DCDFE6"
                    :active-value="true"
                    :inactive-value="false"
                  >
                  </el-switch>
                </div>
              </div>
              <div
                class="date-container"
                v-if="offlineSubscription.invoiceRequired"
              >
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">開票Email</label>
                  <el-input
                    class="input-date"
                    v-model="offlineSubscription.invoiceEmail"
                    type="text"
                    placeholder="請輸入開票Email"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">開票類型</label>
                  <el-select
                    v-model="offlineSubscription.invoiceType"
                    placeholder="請選擇開票類型"
                  >
                    <el-option label="B2C" value="B2C" />
                    <el-option label="B2B" value="B2B" />
                  </el-select>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">開票序號</label>
                  <el-input
                    class="input-date"
                    v-model="offlineSubscription.invoiceNo"
                    type="text"
                    placeholder="請輸入開票序號"
                  >
                  </el-input>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">支付備註</label>
                  <el-input
                    class="input-date"
                    v-model="offlineSubscription.paymentRemark"
                    type="text"
                    placeholder="請輸入支付備註"
                  >
                  </el-input>
                </div>
                <template v-if="offlineSubscription.invoiceType == 'B2B'">
                  <div
                    class="date-input-group"
                    style="width: 24%; min-width: 24%"
                  >
                    <label class="date-label">統一編碼</label>
                    <el-input
                      class="input-date"
                      v-model="
                        offlineSubscription.invoiceBuyer.customerIdentifier
                      "
                      type="text"
                      placeholder="請輸入	8 位数字统一编号"
                    >
                    </el-input>
                  </div>
                  <div
                    class="date-input-group"
                    style="width: 24%; min-width: 24%"
                  >
                    <label class="date-label">客戶名稱</label>
                    <el-input
                      class="input-date"
                      v-model="offlineSubscription.invoiceBuyer.customerName"
                      type="text"
                      placeholder="請輸入客戶名稱"
                    >
                    </el-input>
                  </div>
                  <div
                    class="date-input-group"
                    style="width: 24%; min-width: 24%"
                  >
                    <label class="date-label">客戶地址</label>
                    <el-input
                      class="input-date"
                      v-model="offlineSubscription.invoiceBuyer.customerAddr"
                      type="text"
                      placeholder="請輸入客戶地址"
                    >
                    </el-input>
                  </div>
                </template>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                >
                  <label class="date-label">載具類型</label>
                  <el-select
                    v-model="offlineSubscription.invoiceBuyer.carrierType"
                    placeholder="請選擇載具類型"
                  >
                    <el-option label="不使用載具" value="0" />
                    <el-option label="使用手機條碼載具" value="1" />
                  </el-select>
                </div>
                <div
                  class="date-input-group"
                  style="width: 24%; min-width: 24%"
                  v-if="offlineSubscription.invoiceBuyer.carrierType === '1'"
                >
                  <label class="date-label">載具號</label>
                  <el-input
                    class="input-date"
                    v-model="offlineSubscription.invoiceBuyer.carrierNum"
                    type="text"
                    placeholder="請輸入載具號"
                  >
                  </el-input>
                </div>
              </div>
            </template>
          </div>
          <div class="dialog-footer" style="margin-top: 0.2rem">
            <el-button size="" @click="showAdd = false"> 取 消 </el-button>
            <el-button size="" type="primary" @click="addStudent">
              {{ isEdit ? "保存" : "新增學生" }}
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="溫馨提示"
      :visible.sync="dialogVisible"
      width="30%"
      style="align-items: center; justify-content: center"
      :center="true"
    >
      <span>確認要刪除該學生嗎？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureDelete"> 确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiBaseUrl } from "../../api/config";
export default {
  components: {},
  data() {
    return {
      baseUrl: apiBaseUrl,
      page: 1,
      dataList: [],
      search: {
        studentId: "",
        keyword: "",
        phone: "",
        email: "",
        userType: "",
        status: "",
        studentStage: "",
        city: "",
        beginCreateTime: "",
        beginLoginDate: "",
        beginSubscriptionExpireTime: "",
        endSubscriptionExpireTime: "",
        hasPaidSubscription: "",
        subscriptionStatus: "",
        pageSize: 10,
      },
      showAdd: false,
      post: {
        email: "",
        phone: "",
        password: "",
        userType: "student",
        avatar: "",
        nickname: "",
        city: "", //城市
        googleAuthId: "", //google授权id
        lineId: "", //LINE 授权 ID。
        targetSchoolType: "", //目标学校类型。
        commuteDistancePreference: "", //通勤距离偏好。
        examScores: "", //会考成绩 JSON 字符串。
        totalScore: "", //会考总分。
        importantNoticeEnabled: 0, //重要通知开关，0 或 1。
        serviceUpdateEnabled: 0, //服务更新开关，0 或 1。
        serviceExpiryEnabled: 0, //到期提醒开关，0 或 1。
        status: "0", //账号状态，0 或 1。
        remark: "", //备注。
        loginIp: "", //最近登录 IP。
        loginDate: "", //最近登录时间。
        lastPasswordModifyTime: "", //最后改密时间。
        availableCount: "", //可用次数。
        //aiRemainCount: "", //AI 免费剩余次数。
        // aiSubscriptionRemainCount: "", //AI 订阅剩余次数。
        name: "", //姓名。
        studentStage: "", //學制。
        // subscriptionExpireTime: "", //订阅到期日。
        schoolName: "", //就读学校。
        currentChatQuotaType: "", //当前聊天配额类型。
        currentChatQuotaRemaining: "", //当前聊天配额剩余次数。
        currentChatQuotaUsed: "", //当前聊天配额已用次数。
        currentChatQuotaLimit: "", //当前聊天配额限制次数。
        welcomeChatBenefitExpireTime: "", //欢迎聊天权益到期时间。
      },
      offlineSubscription: {
        merchantTradeNo: "", //全局唯一业务订单号，最长 32 位
        planId: "", //已启用套餐 ID
        paidAmount: "", //实收金额，大于 0，最多两位小数
        discountReason: "", //实收金额与套餐售价不一致时必填，最多 200 字
        paidTime: "", //	ISO-8601 LocalDateTime，例如 2026-10-09T10:00:00
        paymentMethod: "", //OFFLINE_BANK、OFFLINE_CASH 或 OFFLINE_TRANSFER
        invoiceRequired: true, //是否开票，默认 true
        invoiceEmail: "", //发票收件邮箱
        invoiceType: "", //B2C 或 B2B 发票类型
        invoiceNo: "", //纸本发票号码
        paymentRemark: "", //付款备注
        invoiceBuyer: {
          customerIdentifier: "", //B2B 时必填	8 位数字统一编号
          customerName: "", //	B2B 时必填	买方名称
          customerAddr: "", //	买方地址
          carrierType: "", //	载具类型
          carrierNum: "", //	载具号码
        },
      },
      isEdit: false,
      dialogVisible: false,
      detailStudent: {},
      sys_area: [],
      dataTotal: 0,
      showMoreInput: false,
      plans: [],
      studentStageList: [],
      chatQuotaTypes: [
        {
          value: "SUBSCRIPTION",
          label: "付费订阅额度",
        },
        {
          value: "WELCOME_BENEFIT",
          label: "欢迎语权益额度",
        },
        {
          value: "FREE",
          label: "普通免费额度",
        },
        {
          value: "NONE",
          label: "无对应学生或无可用额度类型",
        },
      ],
    };
  },
  mounted() {
    this.initData();
    this.$axios
      .post("rest-api/system/app/common/dict-data/list", {
        dictType: "sys_area",
      })
      .then((res) => {
        this.sys_area = res.data;
      });
    this.$axios
      .get("rest-api/member/app/subscription/plans", {})
      .then((res) => {
        this.plans = res.data;
      });
    this.$axios
      .post("rest-api/system/app/common/dict-data/list", {
        dictType: "student_stage",
      })
      .then((res) => {
        this.studentStageList = res.data;
      });
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.post.avatar = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    addStudent() {
      const that = this;

      if (that.isEdit) {
        that.$axios
          .post("rest-api/member/app/student/edit", that.post)
          .then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.showAdd = false;
            this.initData();
          })
          .catch((err) => {});
        return;
      }

      const params = {};
      if (that.offlineSubscription.merchantTradeNo) {
        params.student = {
          ...that.post,
        };
        params.offlineSubscription = that.offlineSubscription;

        that.$axios
          .post(
            "rest-api/member/app/student/with-offline-payment",
            JSON.stringify(params),
          )
          .then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.showAdd = false;
            this.initData();
          })
          .catch((err) => {});
      } else {
        that.$axios
          .post("rest-api/member/app/student/add", that.post)
          .then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.showAdd = false;
            this.initData();
          })
          .catch((err) => {});
      }
    },
    toSee(item, isEdit) {
      const that = this;
      that.isEdit = isEdit;

      that.$axios
        .post("rest-api/member/app/student/detail", {
          id: item.id,
        })
        .then((res) => {
          that.post = {
            ...that.post,
            ...res.data,
          };
          that.showAdd = true;
        })
        .catch((err) => {});
    },
    toAdd() {
      const that = this;
      this.isEdit = false;

      that.post = {
        email: "",
        phone: "",
        password: "",
        userType: "student",
        avatar: "",
        nickname: "",
        city: "", //城市
        googleAuthId: "", //google授权id
        lineId: "", //LINE 授权 ID。
        targetSchoolType: "", //目标学校类型。
        commuteDistancePreference: "", //通勤距离偏好。
        examScores: "", //会考成绩 JSON 字符串。
        totalScore: "", //会考总分。
        importantNoticeEnabled: 0, //重要通知开关，0 或 1。
        serviceUpdateEnabled: 0, //服务更新开关，0 或 1。
        serviceExpiryEnabled: 0, //到期提醒开关，0 或 1。
        status: "0", //账号状态，0 或 1。
        remark: "", //备注。
        loginIp: "", //最近登录 IP。
        loginDate: "", //最近登录时间。
        lastPasswordModifyTime: "", //最后改密时间。
        availableCount: "", //可用次数。
        // aiRemainCount: "", //AI 免费剩余次数。
        // aiSubscriptionRemainCount: "", //AI 订阅剩余次数。
        name: "", //姓名。
        studentStage: "", //學制。
        // subscriptionExpireTime: "", //订阅到期日。
        schoolName: "", //就读学校。
        currentChatQuotaType: "", //当前聊天配额类型。
        currentChatQuotaRemaining: "", //当前聊天配额剩余次数。
        currentChatQuotaUsed: "", //当前聊天配额已用次数。
        currentChatQuotaLimit: "", //当前聊天配额限制次数。
        welcomeChatBenefitExpireTime: "", //欢迎聊天权益到期时间。
      };
      that.offlineSubscription = {
        merchantTradeNo: "", //全局唯一业务订单号，最长 32 位
        planId: "", //已启用套餐 ID
        paidAmount: "", //实收金额，大于 0，最多两位小数
        discountReason: "", //实收金额与套餐售价不一致时必填，最多 200 字
        paidTime: "", //	ISO-8601 LocalDateTime，例如 2026-10-09T10:00:00
        paymentMethod: "", //OFFLINE_BANK、OFFLINE_CASH 或 OFFLINE_TRANSFER
        invoiceRequired: true, //是否开票，默认 true
        invoiceEmail: "", //发票收件邮箱
        invoiceType: "", //B2C 或 B2B 发票类型
        invoiceNo: "", //纸本发票号码
        paymentRemark: "", //付款备注
        invoiceBuyer: {
          customerIdentifier: "", //B2B 时必填	8 位数字统一编号
          customerName: "", //	B2B 时必填	买方名称
          customerAddr: "", //	买方地址
          carrierType: "", //	载具类型
          carrierNum: "", //	载具号码
        },
      };
      this.showAdd = true;
    },
    deleteStudent(item) {
      const that = this;
      that.dialogVisible = true;
      that.detailStudent = item;
    },
    sureDelete() {
      const that = this;
      that.$axios
        .post("rest-api/member/app/student/remove", {
          id: that.detailStudent.id,
        })
        .then((res) => {
          that.initData();
          that.dialogVisible = false;
          that.$message({
            message: "操作成功",
            type: "success",
          });
        })
        .catch((err) => {});
    },
    currentChange(e) {
      this.page = e;
      this.getList();
    },
    initData() {
      this.page = 1;
      this.getList();
    },
    getList() {
      const that = this;
      that.$axios
        .post("rest-api/member/app/student/page", {
          pageNum: that.page,
          ...that.search,
        })
        .then((res) => {
          that.dataList = res.data.list;
          that.dataTotal = res.data.total;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.recruitment-dashboard {
  min-height: 100vh;
  background: #eef3f6;
  padding: 0.2rem;
}

/* 頂部標題欄 */
.dashboard-header {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.help-btn {
  background: #4a5568;
  color: white;
  border: none;
  padding: 0.08rem 0.2rem;
  border-radius: 0.06rem;
  font-size: 0.2rem;
  cursor: pointer;
}

/* 日期選擇區域 */
.date-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
}

.date-container {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
}

.date-input-group {
  width: 32%;
  min-width: 32%;
  margin-right: 1%;
  margin-bottom: 0.2rem;
}

.date-label {
  display: flex;
  align-items: center;
  margin-bottom: 0.08rem;
  color: #222;
  font-size: 0.18rem;
}

.date-input {
  background: #91a2a41a;
  border: 0.01rem solid #91a2a480;
  border-radius: 0.08rem;
  font-size: 0.2rem;
  padding: 0.12rem 0.1rem;
  color: #999;
}

/* 核心數據指標 */
.kpi-section {
  flex: 1;
  margin-right: 0.1rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
}

.section-title {
  font-weight: bold;
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
  color: #2d3748;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1.8rem, 1fr));
  gap: 0.2rem;
}

.kpi-card {
  background: white;
  position: relative;
  border-radius: 0.12rem;
  padding: 0.25rem;
  box-shadow: 0.04rem 0.04rem 0.2rem 0rem #27545726;

  .ic-block {
    width: 0.5rem;
    height: 0.5rem;
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
  }
}

.kpi-header {
  margin-bottom: 00.17rem;
}

.kpi-name {
  font-size: 0.18rem;
  color: #777;
}

.kpi-value {
  font-size: 0.32rem;
  color: #000;
  margin-bottom: 0.4rem;
}

.kpi-comparison {
  display: flex;
  align-items: center;
  gap: 0.06rem;
  font-size: 0.12rem;
}

.kpi-comparison.positive {
  color: #21c93a;
}

.trend-icon {
  font-weight: bold;
}

/* 主要內容區域 */
.main-content {
  flex: 1;
  margin-left: 0.1rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
}

.content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 0.3rem;
}

/* 排行榜樣式 */
.ranking-section {
  flex: 1;
  margin-left: 0.1rem;
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
}

.ranking-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.1rem;
}

.ranking-title {
  font-size: 0.2rem;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 0.2rem;
}

.ranking-table {
  border: 0.01rem solid #27545726;
  border-radius: 0.1rem;
  margin-top: 0.2rem;
  overflow: hidden;
}

.ranking-date {
  color: #718096;
  font-size: 0.2rem;
}

.ranking-subtitle {
  color: #718096;
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
}

.table-header {
  display: flex;
  padding: 0.12rem 0;
  border-bottom: 0.01rem solid #e2e8f0;
  background: #0ba29b0f;
  color: #4a5568;
  font-size: 0.18rem;
}

.table-header span {
  flex-grow: 1;
  flex-shrink: 1;
  text-align: center;
}

.table-row span {
  flex-grow: 1;
  flex-shrink: 1;
  word-break: break-all;
  text-align: center;
}
span.w1 {
  width: 10%;
}
span.w2 {
  width: 20%;
}
span.w3 {
  width: 30%;
}
span.wp5 {
  width: 5%;
}
.table-row {
  display: flex;
  padding: 0.12rem 0;
  font-size: 0.18rem;
  border-bottom: 0.01rem solid #e2e8f0;
}

.rank {
  color: #4a5568;
}

.department {
  color: #2d3748;
}

.area,
.rate {
  text-align: right;
  color: #4a5568;
}

/* 篩選區域樣式 */
.filter-section {
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
}

.filter-group {
  display: flex;
  gap: 0.1rem;
  margin-bottom: 0.2rem;
}

.filter-btn {
  flex: 1;
  padding: 0.1rem;
  border: 0.01rem solid #e2e8f0;
  background: #f7fafc;
  border-radius: 0.08rem;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-btn.active {
  background: #667eea;
  color: white;
  border-color: #667eea;
}

.primary-btn {
  width: 100%;
  padding: 0.12rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 0.08rem;
  font-size: 0.2rem;
  cursor: pointer;
  margin-bottom: 0.2rem;
}

.dropdown {
  width: 100%;
  padding: 0.12rem;
  border: 0.01rem solid #e2e8f0;
  border-radius: 0.08rem;
  background: white;
  margin-bottom: 0.2rem;
}

.stats-info {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.stat-item {
  padding: 0.1rem;
  background: #f7fafc;
  border-radius: 0.06rem;
  text-align: center;
  color: #718096;
  font-size: 0.2rem;
}

/* 響應式設計 */
@media (max-width: 1024px) {
  .content-grid {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }
}

@media (max-width: 768px) {
  .recruitment-dashboard {
    padding: 0.1rem;
  }

  .header-content {
    flex-direction: column;
    gap: 00.17rem;
    align-items: flex-start;
  }

  .date-container {
    flex-direction: column;
    gap: 00.17rem;
  }

  .kpi-grid {
    grid-template-columns: 1fr;
  }

  .table-header,
  .table-row {
    grid-template-columns: 0.5rem 1fr 0.8rem 0.7rem;
    gap: 0.1rem;
    font-size: 0.2rem;
  }

  .filter-group {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .kpi-value {
    font-size: 0.24rem;
  }

  .table-header,
  .table-row {
    grid-template-columns: 0.4rem 1fr 0.7rem 0.6rem;
    gap: 0.08rem;
  }

  .ranking-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.1rem;
  }
}

.search-title {
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 0.28rem;
}

.modle-block2 {
  display: flex;
}

@media (max-width: 1024px) {
  .modle-block2 {
    display: block;
  }

  .kpi-section {
    margin-right: 0;
  }

  .ranking-section {
    margin-left: 0;
  }
}

/* 页面标题 */
.era-header {
  margin-bottom: 0.3rem;
}

.era-main-title {
  font-size: 0.28rem;
  font-weight: 700;
  color: #2d3748;
  text-align: center;
}

/* 内容网格布局 */
.era-content-grid {
  display: grid;
  // grid-template-columns: 2fr 1fr;
  gap: 0.3rem;
  margin: 0 auto;
}

/* 排行榜区域 */
.era-section-header {
  margin: 0 0 0.2rem;
}

.era-section-title {
  font-weight: bold;
  color: #2d3748;
  justify-content: space-between;

  .title-btn {
    background: #0ba29b;
    padding: 0.12rem;
    border-radius: 0.06rem;
    color: #fff;
    cursor: pointer;
    font-size: 0.2rem;
  }

  .tips {
    font-weight: normal;
    font-size: 0.12rem;
    color: #ed6d00;
    margin-left: 0.3rem;
  }

  img {
    width: 0.2rem;
    height: 0.2rem;
    margin-right: 0.06rem;
  }
}

.era-section-title-sub {
  font-size: 00.17rem;
  font-weight: bold;
  color: #0ba29b;
  margin-bottom: 0.2rem;
  margin-top: 0.2rem;
}

/* 表格样式 */
.era-table-container {
  overflow-x: auto;
}

.era-ranking-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.2rem;
}

.era-ranking-table th {
  background: #f8fafc;
  padding: 0.12rem 0.08rem;
  text-align: left;
  font-weight: bold;
  color: #4a5568;
  border-bottom: 0.02rem solid #e2e8f0;
}

.era-ranking-table td {
  padding: 0.12rem 0.08rem;
  border-bottom: 0.01rem solid #e2e8f0;
  color: #4a5568;
}

.era-ranking-table .era-highlight-row {
  background: #fffaf0;
}

.era-ranking-table .era-highlight-row td {
  font-weight: 500;
}

.era-rank-col {
  width: 0.6rem;
}

.era-name-col {
  min-width: 2rem;
}

.era-private-col {
  width: 1.2rem;
}

.era-growth-col {
  width: 1rem;
}

.era-school-col {
  width: 1.4rem;
}

.era-rank-cell {
  text-align: center;
}

.era-rank-number {
  display: inline-block;
  width: 0.28rem;
  height: 0.28rem;
  line-height: 0.28rem;
  text-align: center;
  background: #667eea;
  color: white;
  border-radius: 50%;
  font-size: 0.12rem;
  font-weight: bold;
}

.era-ranking-table .era-highlight-row .era-rank-number {
  background: #ed8936;
}

.era-name-cell {
  color: #2d3748;
  font-weight: 500;
}

.era-growth-cell {
  text-align: center;
}

.era-growth-rate.era-positive {
  color: #48bb78;
  font-weight: bold;
}

.era-school-cell {
  text-align: right;
}

/* 右侧数据面板 */
.era-stats-panel {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 0.4rem;
}

.era-chart-section,
.era-quality-section {
  background: #eef6f685;
  border-radius: 00.17rem;
  padding: 0 00.17rem 00.17rem;
}

.era-chart-title {
  font-size: 0.2rem;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 0.2rem;
}

/* 管道列表 */
.era-channel-list {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.era-channel-item {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.08rem 0;
}

.era-channel-dot {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 50%;
}

.era-channel-dot.era-organic {
  background: #48bb78;
}

.era-channel-dot.era-referral {
  background: #ed8936;
}

.era-channel-dot.era-social {
  background: #9f7aea;
}

.era-channel-dot.era-paid {
  background: #4299e1;
}

.era-channel-dot.era-direct {
  background: #f56565;
}

.era-channel-name {
  color: #4a5568;
  font-size: 0.2rem;
}

/* 品质评比表格 */
.era-quality-table {
  display: flex;
  flex-direction: column;
  gap: 00.17rem;
}

.era-table-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 00.17rem;
  padding-bottom: 0.1rem;
  border-bottom: 0.02rem solid #e2e8f0;
  font-weight: bold;
  color: #4a5568;
  font-size: 0.12rem;
}

.era-table-body {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.era-table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 00.17rem;
  align-items: center;
}

.era-channel-cell {
  font-size: 0.12rem;
  color: #4a5568;
  font-weight: 500;
}

.era-progress-cell {
  position: relative;
}

.era-progress-bar {
  position: relative;
  height: 0.24rem;
  background: #f7fafc;
  border-radius: 0.12rem;
  overflow: hidden;
}

.era-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 0.12rem;
  transition: width 0.3s ease;
}

.era-progress-fill.era-depth-fill {
  background: linear-gradient(90deg, #48bb78, #38a169);
}

.era-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.11rem;
  font-weight: bold;
  color: #2d3748;
  z-index: 1;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .era-content-grid {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }

  .era-stats-panel {
    flex-direction: row;
  }

  .era-stats-panel {
    padding-top: 0;
  }

  .era-chart-section,
  .era-quality-section {
    flex: 1;
  }

  .page-title {
    display: block;

    .page-title-btn {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
    }
  }
}

@media (max-width: 768px) {
  .date-input-group {
    width: 100%;
    min-width: 100%;
    margin: 0;
  }

  .dialog-account {
    width: 90% !important;
  }

  .era-container {
    padding: 00.17rem;
  }

  .era-section-title {
    .tips {
      margin-left: 0;
      margin-top: 00.17rem;
    }
  }

  .era-main-title {
    font-size: 0.22rem;
  }

  .era-content-grid {
    gap: 00.17rem;
  }

  .era-stats-panel {
    flex-direction: column;
  }

  .era-ranking-table {
    font-size: 0.12rem;
  }

  .era-ranking-table th,
  .era-ranking-table td {
    padding: 0.08rem 0.06rem;
  }

  .era-name-col {
    min-width: 1.5rem;
  }

  .era-private-col {
    width: 1rem;
  }

  .era-growth-col {
    width: 0.8rem;
  }

  .era-school-col {
    width: 1.2rem;
  }
}

@media (max-width: 480px) {
  .era-container {
    padding: 0.1rem;
  }

  .era-main-title {
    font-size: 0.2rem;
  }

  .era-ranking-table {
    font-size: 0.11rem;
  }

  .era-ranking-table th,
  .era-ranking-table td {
    padding: 0.06rem 0.04rem;
  }

  .era-table-header,
  .era-table-row {
    grid-template-columns: 1fr 1fr;
    gap: 0.1rem;
  }

  .era-table-header .era-depth-header,
  .era-table-row .era-progress-cell:last-child {
    display: none;
  }

  .era-rank-number {
    width: 0.24rem;
    height: 0.24rem;
    line-height: 0.24rem;
    font-size: 0.11rem;
  }
}

.era-content-grid {
  margin-top: 0.2rem;
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.08);
}

.page-title {
  justify-content: space-between;
  margin: 0 0 0.3rem;

  .page-title-main {
    font-size: 0.26rem;
    font-weight: bold;
  }

  .page-title-sub {
    color: #0ba29b;
    font-size: 0.22rem;
    font-weight: bold;
    margin-top: 0.12rem;
  }
}

.module-show {
  background: #ed6d001a;
  color: #ed6d00;
  font: size 0.2rem;
  padding: 0.2rem;
  margin-top: 0.3rem;
}

.tips1 {
  background: #ed6d001a;
  border-radius: 16px;
  font-size: 0.12rem;
  color: #ed6d00;
  padding: 0.08rem 0.2rem;
}

.item-btn {
  display: flex;
  justify-content: center;

  .btn {
    cursor: pointer;
    padding: 0 0.05rem;
  }

  .btn-edit {
    color: #0ba29b;
  }

  .btn-del {
    color: #ff383c;
  }
}

.module-count {
  background: #f3f3f3;
  border: 1px dashed #275457;
  border-radius: 10px;
  padding: 0.3rem 0.24rem;

  .module-header {
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }
}

.btn-add {
  background: #0ba29b;
  padding: 0.12rem;
  border-radius: 0.06rem;
  color: #fff;
  font-size: 0.2rem;
  margin-top: 0.2rem;
}

.input-tips {
  font-size: 0.12rem;
  color: #999;
}

.title {
  font-size: 0.2rem;
  color: #222;
  margin-top: 0.24rem;
  margin-bottom: 0.24rem;
  display: flex;
  justify-content: space-between;
}

.dialog-account {
  width: 8rem;
  margin: 0 auto;

  ::v-deep .el-dialog {
    width: 100% !important;
    overflow: auto;
  }
}

.module-role {
  border-top: 1px dashed #e1e1e1;
  padding-top: 0.3rem;
  margin-top: 0.3rem;
}

.module-contract-add {
  position: fixed;
  top: 0;
  right: -100%;
  opacity: 0;
  transition: 0.5s ease-in-out;
  width: 30%;
  z-index: 100;
  bottom: 0;
  display: block;
  background-color: #f7f8fc;
  padding: 0.2rem;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.2);
}

.module-contract-add .date-input-group {
  width: 100%;
  min-width: 100%;
  margin: 0 0 0.2rem;
}

.module-contract-add.show {
  opacity: 1;
  right: 0;
}

.contract-list {
  .item {
    margin-bottom: 0.24rem;
  }

  .item-date {
    font-size: 0.14rem;
    font-weight: bold;
  }

  .item-content {
    border: 1px solid #949baa4d;
    border-radius: 5px;
    padding: 0.06rem 0.12rem;
    margin-top: 0.1rem;
  }

  .item-show {
    font-size: 0.14rem;
    display: flex;
    justify-content: space-between;
    padding: 0.06rem;
  }
}

@media (max-width: 1024px) {
  .module-contract-add {
    width: 90%;
  }

  .module-contract-add .date-input-group {
    margin: 0;
  }
}
.page-filter .input-date {
  width: 22.5% !important;
}
.avatar-uploader {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  height: 0.4rem;
  width: 0.4rem;
}
</style>
